export default __webpack_public_path__ + "static/media/markingShade.adb0fc5b.png";